/* @flow */
import * as React from 'react';

const ArrowWhiteLeft = props => (
  <svg width={16} height={12} viewBox="0 0 16 12" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      fillRule="evenodd"
      d="M15,5 L2,5 L6,1 C6.367,0.675 6.376,0.359 6,0 C6.088,0.053 5.956,0 6,0 C5.7,0 5.576,0.045 5,0 L0,5 C0.156,5.137 0.155,5.14 0,5 C0.149,5.146 0.145,5.149 0,5 C0.139,5.155 0.137,5.156 0,5 C0.118,5.176 0.111,5.2 0,5 C0.091,5.227 0.086,5.235 0,5 C0.069,5.263 0.05,5.281 0,5 C0.04,5.307 0.039,5.312 0,5 C0.025,5.346 0.023,5.376 0,5 C0.013,5.436 0.002,5.463 0,5 C0.001,5.495 0,5.497 0,6 C0,5.502 0.001,5.505 0,6 C0.002,5.537 0.013,5.564 0,6 C0.024,5.624 0.025,5.654 0,6 C0.039,5.688 0.04,5.693 0,6 C0.05,5.719 0.069,5.736 0,6 C0.086,5.765 0.091,5.772 0,6 C0.111,5.801 0.118,5.824 0,6 C0.137,5.844 0.139,5.845 0,6 C0.145,5.851 0.149,5.854 0,6 C0.154,5.86 0.155,5.862 0,6 L5,11 C5.68,11.053 5.996,11.043 6,11 C6.376,10.641 6.365,10.325 6,10 L2,6 L15,6 C15.776,6 16,5.776 16,6 C16,5.224 15.776,5 15,5 Z"
    />
  </svg>
);

export default ArrowWhiteLeft;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-white-left.js